import "./Loader.scss"

export interface LoaderComponentProps {
  size?: "sm" | "lg"
  label?: string
  className?: string
  fillPage?: boolean
}

export const LoaderComponent = ({
  size = "lg",
  label = "Loading…",
  className = "",
  fillPage = false,
}: LoaderComponentProps) => {
  const loader = (
    <div
      className={`app-loader app-loader--${size}${className ? ` ${className}` : ""}`}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="app-loader__spinner">
        <span className="app-loader__ring-glow" aria-hidden="true" />
        <span className="app-loader__ring" aria-hidden="true" />
      </div>
      {size === "lg" && label ? (
        <p className="app-loader__label">{label}</p>
      ) : null}
    </div>
  )

  if (fillPage) {
    return <div className="app-page-loading">{loader}</div>
  }

  return loader
}
